import { apiEmpleo } from "../../util/ApiEmpleo";
import { TServiceHolderState } from "./types";

export type TCreateServiceHolderRequest = {
  id: string;
  Estado?: TServiceHolderState;
  Usuarios_a_cuidar: number;
  Unidad_de_convivencia: string;
  Direccion: string;
  Codigo_postal: string;
  Ciudad: string;
  Region: string;
  Area: string;
  Latitud?: string | null;
  Longitud?: string | null;
  Estado_U1?: string;
  Nombre_U1: string;
  Primer_apellido_U1: string;
  Segundo_apellido_U1: string;
  Fecha_de_nacimiento_U1?: string;
  DNI_U1: string;
  Patologias_U1?: string[];
  Comentarios_patologias_U1?: string;
  Habla_expresion_U1?: string;
  Medicacion_U1?: string;
  Dieta?: string;
  Movilidad_U1?: string[];
  Peso_U1?: number;
  Altura_U1?: number;
  Estado_emocional_y_caracter_U1?: string[];
  Adaptaci_n_de_cuidados_U1?: string;
  Comentarios_estado_emocional_y_caracter_U1?: string;
  Actividades_y_aficiones_U1?: string;
  Calidad_del_sue_o_U1?: string;
  Indicaciones_del_sueno_U1?: string;
  Aseo_U1?: string[];
  Indicaciones_del_aseo_U1?: string;
  Estado_U2?: string;
  Nombre_U2?: string;
  Primer_apellido_U2?: string;
  Segundo_apellido_U2?: string;
  Fecha_de_nacimiento_U2?: string;
  DNI_U2?: string;
  Patologias_U2?: string[];
  Comentarios_patologias_U2?: string;
  Habla_expresion_U2?: string;
  Medicacion_U2?: string;
  Dieta_U2?: string;
  Movilidad_U2?: string[];
  Peso_U2?: number;
  Altura_U2?: number;
  Estado_emocional_y_caracter_U2?: string[];
  Adaptaci_n_de_cuidados_U2?: string;
  Comentarios_estado_emocional_y_caracter_U2?: string;
  Actividades_y_aficiones_U2?: string;
  Calidad_del_sue_o_U2?: string;
  Indicaciones_del_sueno_U2?: string;
  Aseo_U2?: string[];
  Indicaciones_del_aseo_U2?: string;
  Tipo_de_vivienda?: string;
  Caracteristicas_de_la_vivienda?: string[];
  Proveedor_de_Teleasistencia?: string;
  Comunicacion_con_transporte_publico?: string;
  Notas_coordinadora?: string;
  Source?: string;
  Lead_External_ID?: string | null;
  Referente_B2B?: string | null;
};

const apiCreateServiceHolder = async (
  serviceHolderId: string,
  serviceHolder: TCreateServiceHolderRequest
) => {
  if (serviceHolder.Referente_B2B) {
    serviceHolder.Referente_B2B = `/api/company_b2bs/${serviceHolder.Referente_B2B}`;
  }

  let res = await apiEmpleo.post(`service_holders`, serviceHolder, {
    headers: {
      "Content-Type": "application/ld+json",
    },
  });

  return res;
};

export { apiCreateServiceHolder };
